<div class="ui special listing cards m-0 no shadow">
  <div class="ui fluid card no shadow m-0">
    <div class="blurring dimmable image m-0">
      <a
        class="ui tiny circular icon white button"
        (click)="showFavPopup(screenListing)"
      >
        <i
          [ngClass]="
            isFavourite ? 'heart red icon' : 'heart outline pink icon default'
          "
        ></i>
      </a>
      <ng-container *ngIf="isTrendingswiperActive === true; else swiperActive">
        <ng-container *ngIf="screenListing?.screenImages | isArrayValid">
          <img src="{{ screenListing?.screenImages[0]?.url }}" />
        </ng-container>
      </ng-container>
      <ng-template #swiperActive>
        <ng-container>
          <swiper class="screen-image-swiper" [config]="imageSwiperconfig">
            <ng-container *ngFor="let screenimg of screenListing?.screenImages">
              <img src="{{ screenimg.url }}" class="no shadow" />
            </ng-container>
          </swiper>
        </ng-container>
      </ng-template>
    </div>
    <div class="content no border">
      <h5 class="ui mini rating header fw-100">
        <i class="star yellow large icon"></i>
        4.5
      </h5>
      <a
        class="header screen title"
        [routerLink]="['/listing', screenListing?.id]"
      >
        {{ screenListing?.screenName }}
      </a>
      <div class="meta address">
        {{ screenListing?.address }}
      </div>
      <div class="meta price">
        <span class="date">
          <h3 class="ui header">
            {{
              screenListing?.screenPrice | currency: 'INR':'symbol':'1.0'
            }}/sec
          </h3>
        </span>
        <ng-container [ngSwitch]="isListingAddedToBooking">
          <div *ngSwitchCase="true" class="cart button">
            <button
              class="ui right floated icon red circular button"
              (click)="removeScreenFromBooking()"
            >
              <i class="trash icon"></i>
            </button>
          </div>
          <div *ngSwitchCase="false" class="cart button">
            <button
              class="ui right floated icon primary circular button"
              (click)="addLisitingToCurrentBooking()"
            >
              <i class="shopping cart icon"></i>
            </button>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
